import { createSlice } from "@reduxjs/toolkit";
import { IOrderDetails } from "../interface/IOrderDetails";

const initialState: IOrderDetails | null = null;

const selectOrderDetailsSlice = createSlice({
  name: "selectOrderDetails",
  initialState,
  reducers: {
    setSelectOrderDetailsInStore: (state: IOrderDetails | null, action: any | null) => {
      return action.payload;
    },
  },
});

export const { setSelectOrderDetailsInStore } = selectOrderDetailsSlice.actions;

export default selectOrderDetailsSlice.reducer;